import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import NotFound from './views/NotFound.vue'
import Dashboard from './views/Dashboard.vue'
import Logout from './views/Logout.vue'
import About from './views/About.vue'
import Help from './views/Help.vue'
import Test from './views/Test.vue'
import TerrainFormPreview from './views/terrain/preview/TerrainFormPreview.vue'
import TerrainTemplateList from './views/terrain/TerrainTemplateList.vue'
import TerrainTemplates from './views/terrain/TerrainTemplates.vue'
import TerrainCampaigns from './views/terrain/TerrainCampaigns.vue'
import TerrainCampaignEdit from './views/terrain/TerrainCampaignEdit.vue'
import TerrainCampaignForm from './views/terrain/TerrainCampaignForm.vue'
import TerrainCrews from './views/terrain/TerrainCrews.vue'
import TerrainCrewForm from './views/terrain/TerrainCrewForm.vue'
import TerrainReviewQueue from './views/terrain/TerrainReviewQueue.vue'
import TerrainCampaignResponses from './views/terrain/TerrainCampaignResponses.vue'
import TerrainPublicAccess from './views/terrain/TerrainPublicAccess.vue'
import TerrainInvitationExchange from './views/terrain/TerrainInvitationExchange.vue'
import TerrainControlledAccess from './views/terrain/TerrainControlledAccess.vue'
import TerrainPrefillInbox from './views/terrain/TerrainPrefillInbox.vue'
import TerrainPrefillManage from './views/terrain/TerrainPrefillManage.vue'
import TerrainResponseCorrection from './views/terrain/TerrainResponseCorrection.vue'

// Notificaciones (centro de notificaciones, transversal a toda la app)
import Notifications from './views/notifications/Notifications.vue'

// Visor
import VisorViewer from './views/visor/VisorViewer.vue'
import VisorMaps from './views/visor/VisorMaps.vue'
import VisorHelp from './views/visor/VisorHelp.vue'
import WikiHome from './views/wiki/WikiHome.vue'
import WikiArticle from './views/wiki/WikiArticle.vue'
import WikiAdmin from './views/wiki/WikiAdmin.vue'
import WikiEditor from './views/wiki/WikiEditor.vue'

// Mapa
import MapViewer from './views/maps/MapViewer.vue'
import Maps from './views/maps/Maps.vue'
import MapsInfo from './views/maps/MapsInfo.vue'
import MapsNew from './views/maps/MapsNew.vue'
import MapsEdit from './views/maps/MapsEdit.vue'
import MapsLogs from './views/maps/MapsLogs.vue'
import MapsDelete from './views/maps/MapsDelete.vue'
import MapsAssignLayers from './views/maps/MapsAssignLayers.vue'
import MapsAssignUsers from './views/maps/MapsAssignUsers.vue'
import MapsAssignGroups from './views/maps/MapsAssignGroups.vue'
import MapsAssignGeoprocessings from './views/maps/MapsAssignGeoprocessings.vue'

// Capas
import Layers from './views/layers/Layers.vue'
import LayersInfo from './views/layers/LayersInfo.vue'
import LayersNew from './views/layers/LayersNew.vue'
import LayersEdit from './views/layers/LayersEdit.vue'
import LayersLogs from './views/layers/LayersLogs.vue'
import LayersDelete from './views/layers/LayersDelete.vue'
import LayersAssignMaps from './views/layers/LayersAssignMaps.vue'
import LayersSymbologies from './views/layers/LayersSymbologies.vue'
import ExternalLayers from './views/layers/ExternalLayers.vue'

// Categorías
import Categories from './views/categories/Categories.vue'
import CategoriesInfo from './views/categories/CategoriesInfo.vue'
import CategoriesNew from './views/categories/CategoriesNew.vue'
import CategoriesEdit from './views/categories/CategoriesEdit.vue'
import CategoriesLogs from './views/categories/CategoriesLogs.vue'
import CategoriesDelete from './views/categories/CategoriesDelete.vue'

// Geoprocesos
// import Geoprocessings from './views/geoprocessings/Geoprocessings.vue'
// import GeoprocessingsInfo from './views/geoprocessings/GeoprocessingsInfo.vue'
// import GeoprocessingsNew from './views/geoprocessings/GeoprocessingsNew.vue'
// import GeoprocessingsEdit from './views/geoprocessings/GeoprocessingsEdit.vue'
// import GeoprocessingsLogs from './views/geoprocessings/GeoprocessingsLogs.vue'
// import GeoprocessingsDelete from './views/geoprocessings/GeoprocessingsDelete.vue'
// import GeoprocessingsAssignMaps from './views/geoprocessings/GeoprocessingsAssignMaps.vue'

// Usuarios
import Users from './views/users/Users.vue'
import UsersInfo from './views/users/UsersInfo.vue'
import UsersNew from './views/users/UsersNew.vue'
import UsersEdit from './views/users/UsersEdit.vue'
import UsersLogs from './views/users/UsersLogs.vue'
import UsersAssignMaps from './views/users/UsersAssignMaps.vue'
import UsersTempPassword from './views/users/UsersTempPassword.vue'
import UsersNotifications from './views/users/UsersNotifications.vue'
import UsersNotificationsEdit from '@/views/users/UsersNotificationsEdit.vue'
import UsersNotificationsCreate from './views/users/UsersNotificationsCreate.vue'
//Grupos
import Groups from './views/groups/Groups.vue'
import GroupsInfo from './views/groups/GroupsInfo.vue'
import GroupsNew from './views/groups/GroupsNew.vue'
import GroupsEdit from './views/groups/GroupsEdit.vue'
import GroupsLogs from './views/groups/GroupsLogs.vue'
import GroupsDelete from './views/groups/GroupsDelete.vue'
import GroupsAssignMaps from './views/groups/GroupsAssignMaps.vue'

//Documentos
import Documents from './views/documents/Documents.vue'
import DocumentsNew from './views/documents/DocumentsNew.vue'
import DocumentsInfo from './views/documents/DocumentsInfo.vue'
import DocumentsEdit from './views/documents/DocumentsEdit.vue'
import DocumentsDelete from './views/documents/DocumentsDelete.vue'

// Monitoreo
import MonitoringGeneral from './views/monitoring/MonitoringGeneral.vue'
import MonitoringCapas from './views/monitoring/MonitoringCapas.vue'
import MonitoringMaps from './views/monitoring/MonitoringMaps.vue'
import MonitoringTerrain from './views/monitoring/MonitoringTerrain.vue'

// Cuenta de usuario
import Account from './views/account/Account.vue'
import AccountChangePassword from './views/account/AccountChangePassword.vue'
import AccountForcedPasswordChange from './views/account/AccountForcedPasswordChange.vue'

import store from './store'
import { guardRedirect } from './components/mixin/navigationRoutes.js'

function wikiAdminGuard(to, from, next) {
  const redirect = guardRedirect(store.getters.getPermissions, 'wiki')
  redirect ? next(redirect) : next()
}

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

Vue.use(Router)

const router = new Router({
  //mode: 'history',
  routes: [
    { path: '/', redirect: '/inicio' },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/inicio',
      name: 'inicio',
      component: Home
    },
    {
      path: '/terreno/plantillas',
      name: 'terrain-templates',
      component: TerrainTemplateList
    },
    {
      path: '/terreno/plantillas/nueva',
      name: 'terrain-templates-new',
      component: TerrainTemplates
    },
    {
      path: '/terreno/plantillas/vista-previa',
      name: 'terrain-form-preview',
      component: TerrainFormPreview
    },
    {
      path: '/terreno/plantillas/:templateId/editar',
      name: 'terrain-templates-edit',
      component: TerrainTemplates
    },
    {
      path: '/terreno/campanas',
      name: 'terrain-campaigns',
      component: TerrainCampaigns
    },
    {
      path: '/terreno/campanas/nueva',
      name: 'terrain-campaign-new',
      component: TerrainCampaignEdit
    },
    {
      path: '/terreno/campanas/:campaignId/editar',
      name: 'terrain-campaign-edit',
      component: TerrainCampaignEdit
    },
	{ path: '/terreno/campanas/:campaignId/prellenado', name: 'terrain-prefill-manage', component: TerrainPrefillManage },
    {
      path: '/terreno/campanas/:campaignId/respuestas',
      name: 'terrain-campaign-responses',
      component: TerrainCampaignResponses
    },
    {
      path: '/terreno/campanas/:campaignId',
      name: 'terrain-campaign-form',
      component: TerrainCampaignForm,
      meta: { allowAnonymous: true }
    },
	{
	  path: '/terreno/acceso/:publicAccessId', name: 'terrain-public-access', component: TerrainPublicAccess, meta: { allowAnonymous: true }
	},
	{ path: '/terreno/acceso-controlado/:recipientAccessId', name: 'terrain-controlled-access', component: TerrainControlledAccess, meta: { allowAnonymous: true } },
	{ path: '/terreno/campanas/:campaignId/casos', name: 'terrain-prefill-inbox', component: TerrainPrefillInbox, meta: { allowAnonymous: true } },
	{
	  path: '/terreno/invitacion', name: 'terrain-invitation-exchange', component: TerrainInvitationExchange, meta: { allowAnonymous: true }
	},
	{
	  path: '/terreno/campanas/:campaignId/respuestas/:responseId/correccion', name: 'terrain-response-correction', component: TerrainResponseCorrection, meta: { allowAnonymous: true }
	},
    {
      path: '/terreno/cuadrillas',
      name: 'terrain-crews',
      component: TerrainCrews
    },
    {
      path: '/terreno/cuadrillas/nueva',
      name: 'terrain-crew-new',
      component: TerrainCrewForm
    },
    {
      path: '/terreno/cuadrillas/:crewId/editar',
      name: 'terrain-crew-edit',
      component: TerrainCrewForm
    },
    {
      path: '/terreno/revision',
      name: 'terrain-review-queue',
      component: TerrainReviewQueue
    },
    { path: '/terreno/auditoria', redirect: '/monitoreo/terreno' },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/wiki/admin/nuevo',
      name: 'wiki-new',
      component: WikiEditor,
      beforeEnter: wikiAdminGuard
    },
    {
      path: '/wiki/admin/:slug/editar',
      name: 'wiki-edit',
      component: WikiEditor,
      beforeEnter: wikiAdminGuard
    },
    {
      path: '/wiki/admin',
      name: 'wiki-admin',
      component: WikiAdmin,
      beforeEnter: wikiAdminGuard
    },
    { path: '/wiki', name: 'wiki', component: WikiHome },
    { path: '/wiki/:slug', name: 'wiki-article', component: WikiArticle },
    {
      path: '/notificaciones',
      name: 'notificaciones',
      component: Notifications
    },
    {
      path: '/visor/ayuda',
      name: 'ayuda del visor',
      component: VisorHelp
    },
    {
      path: '/visor',
      name: 'mapas visor',
      component: VisorMaps
    },
    {
      path: '/visor/:idMap',
      name: 'visor de este mapa',
      component: VisorViewer
    },
    // { 
    //   path: '/acerca-de',
    //   name: 'acerca de',
    //   component: About
    // },
    {
      path: '/ayuda',
      name: 'ayuda',
      component: Help
    },
    {
      path: '/mapas/:idMap/visor',
      name: 'visor',
      component: MapViewer
    },
    {
      path: '/mapas',
      name: 'mapas',
      component: Maps
    },
    {
      path: '/mapas/nuevo-mapa',
      name: 'nuevo-mapa',
      component: MapsNew
    },
    {
      path: '/mapas/:idMap',
      name: 'mapa-idmapa',
      component: MapsInfo
    },
    {
      path: '/mapas/:idMap/editar-mapa',
      name: 'editar-mapa',
      component: MapsEdit
    },
    {
      path: '/mapas/:idMap/historial-de-cambios',
      name: 'historial-de-cambios-mapa',
      component: MapsLogs
    },
    {
      path: '/mapas/:idMap/eliminar-mapa',
      name: 'eliminar-mapa',
      component: MapsDelete
    },
    {
      path: '/mapas/:idMap/asignar-capas',
      name: 'asignar-capas-mapa',
      component: MapsAssignLayers
    },
    {
      path: '/mapas/:idMap/asignar-usuarios',
      name: 'asignar-usuarios-mapa',
      component: MapsAssignUsers
    },
    {
      path: '/mapas/:idMap/asignar-grupos',
      name: 'asignar-grupos-mapa',
      component: MapsAssignGroups
    },
    {
      path: '/mapas/:idMap/asignar-geoprocesos',
      name: 'asignar-geoprocesos-mapa',
      component: MapsAssignGeoprocessings
    },
    {
      path: '/cuenta/cerrar-sesion',
      name: 'cerrar sesion',
      component: Logout
    },
    {
      path: '/capas',
      name: 'capas',
      component: Layers
    },
    {
      path: '/capas/capas-externas',
      name: 'capas-externas',
      component: ExternalLayers,
      // Sin este guard la pantalla se renderiza para cualquiera que escriba la
      // URL a mano. Los datos no se filtran —el backend responde 401— pero el
      // interceptor global de main.js solo reacciona al 403 de sesión inválida,
      // así que el 401 por falta de permiso no saca al usuario de la vista y
      // queda mirando una tabla vacía con un error.
      beforeEnter: (to, from, next) => {
        var redirect = guardRedirect(store.getters.getPermissions, 'layers')
        redirect ? next(redirect) : next()
      }
    },
    {
      path: '/capas/categorias-de-capas',
      name: 'categorias',
      component: Categories
    },
    {
      path: '/capas/categorias-de-capas/nueva-categoria',
      name: 'nueva-categoria',
      component: CategoriesNew
    },
    {
      path: '/capas/nueva-capa',
      name: 'nueva-capa',
      component: LayersNew,
      // El botón "Añadir capa" del panel del mapa ya no se ofrece sin el
      // permiso, pero la URL escrita a mano entraba igual y dejaba al usuario
      // en el formulario para que el backend lo rebotara después (QA-172).
      beforeEnter: (to, from, next) => {
        var redirect = guardRedirect(store.getters.getPermissions, 'layers')
        redirect ? next(redirect) : next()
      }
    },
    {
      path: '/capas/:idLayer',
      name: 'capas-idlayer',
      component: LayersInfo
    },
    {
      path: '/capas/:idLayer/editar-capa',
      name: 'editar-capa',
      component: LayersEdit
    },
    {
      path: '/capas/:idLayer/asignar-mapas',
      name: 'capa-asignar-mapas',
      component: LayersAssignMaps
    },
    {
      path: '/capas/:idLayer/simbologias',
      name: 'simbologias-capa',
      component: LayersSymbologies
    },
    {
      path: '/capas/:idLayer/historial-de-cambios',
      name: 'historial-de-cambios',
      component: LayersLogs
    },
    {
      path: '/capas/:idLayer/eliminar-capa',
      name: 'eliminar-capa',
      component: LayersDelete
    },
    {
      path: '/capas/categorias-de-capas/:idCategory',
      name: 'categorias-idcategory',
      component: CategoriesInfo
    },
    {
      path: '/capas/categorias-de-capas/:idCategory/editar-categoria',
      name: 'editar-categoria',
      component: CategoriesEdit
    },
    {
      path: '/capas/categorias-de-capas/:idCategory/historial-de-cambios',
      name: 'historial-de-cambios-categoria',
      component: CategoriesLogs
    },
    {
      path: '/capas/categorias-de-capas/:idCategory/eliminar-categoria',
      name: 'eliminar-categoria',
      component: CategoriesDelete
    },
    // OCULTAR RUTAS DE GEOPROCESOS
    // {
    //   path: '/geoprocesos',
    //   name: 'geoprocesos',
    //   component: Geoprocessings
    // },
    // {
    //   path: '/geoprocesos/nuevo-geoproceso',
    //   name: 'nuevo-geoproceso',
    //   component: GeoprocessingsNew
    // },
    // {
    //   path: '/geoprocesos/:idGeo',
    //   name: 'geoprocesos-idgeo',
    //   component: GeoprocessingsInfo
    // },
    // {
    //   path: '/geoprocesos/:idGeo/asignar-mapas',
    //   name: 'geoproceso-asignar-mapas',
    //   component: GeoprocessingsAssignMaps
    // },
    // {
    //   path: '/geoprocesos/:idGeo/editar-geoproceso',
    //   name: 'editar-geoproceso',
    //   component: GeoprocessingsEdit
    // },
    // {
    //   path: '/geoprocesos/:idGeo/historial-de-cambios',
    //   name: 'historial-de-cambios-geo',
    //   component: GeoprocessingsLogs
    // },
    // {
    //   path: '/geoprocesos/:idGeo/eliminar-geoproceso',
    //   name: 'eliminar-geoproceso',
    //   component: GeoprocessingsDelete
    // },
    {
      path: '/usuarios',
      name: 'usuarios',
      component: Users
    },
    {
      path: '/usuarios/grupos-de-usuarios',
      name: 'grupos',
      component: Groups
    },
    {
      path: '/usuarios/grupos-de-usuarios/nuevo-grupo',
      name: 'nuevo-grupo',
      component: GroupsNew
    },
    {
      path: '/usuarios/grupos-de-usuarios/:idGroup',
      name: 'grupos-idgroup',
      component: GroupsInfo
    },
    {
      path: '/usuarios/grupos-de-usuarios/:idGroup/editar-grupo',
      name: 'edit-grupo',
      component: GroupsEdit
    },
    {
      path: '/usuarios/grupos-de-usuarios/:idGroup/historial-de-cambios',
      name: 'historial-de-cambios-grupo',
      component: GroupsLogs
    },
    {
      path: '/usuarios/grupos-de-usuarios/:idGroup/eliminar-grupo',
      name: 'eliminar-grupo',
      component: GroupsDelete
    },
    {
      path: '/usuarios/grupos-de-usuarios/:idGroup/asignar-mapas',
      name: 'grupo-asignar-mapas',
      component: GroupsAssignMaps
    },
         {
        path: '/usuarios/notificaciones',
        name: 'notificaciones',
        component: UsersNotifications
    },
    {
        path: '/usuarios/notificaciones/:idNotification/editar-notificacion',
        name: 'UsersNotificationsEdit',
        component: UsersNotificationsEdit
    },
    {
        path: '/usuarios/notificaciones/nueva-notificacion',
        name: 'UsersNotificationsCreate',
        component: UsersNotificationsCreate
    },
    {
      path: '/usuarios/nuevo-usuario',
      name: 'nuevo-usuario',
      component: UsersNew
    },
    {
      path: '/usuarios/:idUser',
      name: 'usuarios-iduser',
      component: UsersInfo
    },
    {
      path: '/usuarios/:idUser/editar-usuario',
      name: 'edit-usuario',
      component: UsersEdit
    },
    {
      path: '/usuarios/:idUser/historial-de-cambios',
      name: 'historial-de-cambios-usuario',
      component: UsersLogs
    },
    {
      path: '/usuarios/:idUser/asignar-mapas',
      name: 'asignar-mapas',
      component: UsersAssignMaps
    },
    {
      path: '/usuarios/:idUser/contrasena-temporal',
      name: 'contrasena-temporal',
      component: UsersTempPassword
    },
    {
      path: '/documentos',
      name: 'documentos',
      component: Documents
    },
    {
      path: '/documentos/nuevo-documento',
      name: 'nuevo-documento',
      component: DocumentsNew
    },
    {
      //Debe ir después de /documentos/nuevo-documento: vue-router resuelve por
      //orden de declaración y :idDoc capturaría 'nuevo-documento'
      path: '/documentos/:idDoc',
      name: 'documentos-iddoc',
      component: DocumentsInfo
    },
    {
      path: '/documentos/:idDoc/editar-documento',
      name: 'editar-documento',
      component: DocumentsEdit
    },
    {
      path: '/documentos/:idDoc/eliminar-documento',
      name: 'eliminar-documento',
      component: DocumentsDelete
    },
    { path: '/monitoreo', redirect: '/monitoreo/general' },
    {
      path: '/monitoreo/general',
      name: 'monitoreo-general',
      component: MonitoringGeneral
    },
    {
      path: '/monitoreo/mapas',
      name: 'monitoreo-mapas',
      component: MonitoringMaps
    },
    {
      path: '/monitoreo/capas',
      name: 'monitoreo-capas',
      component: MonitoringCapas
    },
    {
      path: '/monitoreo/terreno',
      name: 'monitoreo-terreno',
      component: MonitoringTerrain
    },
    {
      path: "/cuenta/mi-cuenta",
      name: 'cuenta usuario',
      component: Account 
    },
    {
      path: "/cuenta/cambiar-contrasena",
      name: 'cambiar contrasena',
      component: AccountChangePassword
    },
    {
      path: "/cuenta/cambiar-contrasena-forzada",
      name: 'cambiar contrasena forzada',
      component: AccountForcedPasswordChange
    },
    {
      path: '/recuperar-contrasena',
      name: 'recuperar contrasena',
      component: () => import('./views/account/RecoverPassword.vue'),
      meta: { allowAnonymous: true }
    },
    { path: '*', redirect: '/pagina-no-encontrada' },
    { 
      path: "/pagina-no-encontrada",
      name: 'not-found',
      component: NotFound 
    }
  ],
  linkActiveClass: "active", // active class for non-exact links.
  //linkExactActiveClass: "active" // active class for *exact* links.
})

router.beforeEach((to, from, next) => {
  var forcedRoute = 'cambiar contrasena forzada';
  if (store.state.mustChangePassword && to.name !== forcedRoute && to.name !== 'inicio' && to.name !== 'recuperar contrasena') {
    return next({ name: forcedRoute });
  }
  next();
})

export default router
